import { Protocol } from '../../types/sharedTypeImpl.ts';
import { DiffPath } from './getChangedPaths.ts';


export function isSignificantChange(change: DiffPath, oldProtocol: Protocol, newProtocol: Protocol): boolean {
    if (isIgnoredField(change)) {
        return false;
    }
    if (isIgnoredIfBothEmpty(change, oldProtocol, newProtocol)) {
        return false;
    }

    const programsField: keyof Protocol = 'programs';
    if (change.startsWith(programsField)) {
        return hasDeletedProgram(oldProtocol, newProtocol);
    }

    return true;
}

function isIgnoredField(change: DiffPath): boolean {
    const ignoredFields: (keyof Protocol)[] = [
        // App controlled paths
        '_id',
        'status',
        'version',
        'analysisVersion',
        'baseProtocol',
        'isCopy',
        'createTime',
        'isDisabled',
        'reviews',
        'requiresPlanReview',

        // User controlled paths
        'user',
        'changes',
    ];

    const isIgnored = (ignoredFields as string[]).includes(change);
    return isIgnored;
}

function hasDeletedProgram(oldProtocol: Protocol, newProtocol: Protocol): boolean {
    for (const oldProgram of oldProtocol.programs) {
        if (!newProtocol.programs.includes(oldProgram)) {
            return true;
        }
    }
    return false;
}

// Ignores situations where an undefined fields becomes an empty string due to a write + delete.
function isIgnoredIfBothEmpty(change: DiffPath, oldProtocol: Protocol, newProtocol: Protocol): boolean {
    const relevantFields: (keyof Protocol)[] = [
        'comment',
        'partRevision'
    ];
    const isRelevantField = (relevantFields as string[]).includes(change);
    if (!isRelevantField) {
        return false;
    }

    const oldValue = (oldProtocol as any)[change];
    const newValue = (newProtocol as any)[change];
    const isOldEmpty = oldValue == null || oldValue === '';
    const isNewEmpty = newValue == null || newValue === '';

    const bothEmpty = isOldEmpty && isNewEmpty;
    return bothEmpty;
}